
var appConfig = require('./app-config-module');

// module.exports = appConfig.useThemeColors();
module.exports = appConfig.createConfig();
